import { useState, useEffect } from "react";
import { oauth } from "../../../utils";
import { PublicViewTemplate } from "../../../interfaces/PublicViewTemplate";
import { useIdentity } from "../../../hooks";

export function usePublicViewTemplates() {
  const [templates, setTemplates] = useState<PublicViewTemplate[]>([]);
  const [layouts, setLayouts] = useState<PublicViewTemplate[]>([]);
  const [commonskuTemplates, setCommonskuTemplates] = useState<
    PublicViewTemplate[]
  >([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<Error | null>(null);
  const { company_id: companyId, company_name: companyName } = useIdentity();

  useEffect(() => {
    async function fetchTemplates() {
      setLoading(true);
      setError(null);
      try {
        const { json } = await oauth("GET", "public-view-template", {
          include_layouts: true,
          include_commonsku_templates: true,
          status: "ALL",
        });

        const layouts = json.layouts ?? [];
        setLayouts(layouts);
        const templates = json.templates ?? [];
        setTemplates(templates);

        const commonsku_templates = json.commonsku_templates ?? [];
        setCommonskuTemplates(commonsku_templates);
      } catch (err) {
        setError(err as Error);
      } finally {
        setLoading(false);
      }
    }

    fetchTemplates();
  }, []);

  return {
    templates,
    layouts,
    commonskuTemplates,
    companyId,
    companyName,
    loading,
    error,
  };
}
